module.exports = __webpack_public_path__ + "0e7b00721c178de04cf4f2e9300cf13d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CX.svg
// module id = n+Tb
// module chunks = 0